import React, { FC } from "react";
import { FallbackProps } from "react-error-boundary";

type Props = FallbackProps;

const ErrorFallback: FC<Props> = ({ error, resetErrorBoundary }) => {
  return (
    <div role="alert">
      <p style={{ color: "black" }}>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
};
export default ErrorFallback;
